// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 483 ? "Shell" : chunkId) + "." + {"131":"3f25b7b2","483":"b50e5530"}[chunkId] + ".chunk.js";
};